(() => {
  const details = document.getElementById('Details-Quick-Navigation');
  if (!details) return;

  const content = details.querySelector('.thb-header-quick-navigation--content');
  const items = content.querySelectorAll(':scope > ul > li.menu-item-has-children');
  const submenus = content.querySelectorAll(':scope > ul > li > .sub-menu');
  const activeCollection = window.location.pathname.split('/').at(-1);

  function syncHeight() {
    const contentHeight = content.offsetHeight;
    submenus.forEach((el) => {
      el.style.height = contentHeight + 'px';
    });
  }

  function setActive(item) {
    items.forEach((el) => el.classList.remove('is-active'));
    item.classList.add('is-active');
    content.classList.add('is-active-content');
  }

  if (activeCollection) {
    const activeItem = [...items].find((item) => item.querySelector('a').href.includes(activeCollection));
    if (activeItem) {
      setActive(activeItem);
    }
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => setActive(item));

    const parentLink = item.querySelector(':scope > a');
    if (parentLink) {
      parentLink.addEventListener('click', (e) => {
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
          if (!item.classList.contains('is-active')) {
            e.preventDefault();
            setActive(item);
          }
        }
      });
    }
  });

  const overlay = details.parentElement.querySelector('.quick-nav--click-capture');

  if (overlay) {
    overlay.addEventListener('click', () => {
      details.removeAttribute('open');
    });
  }

  details.addEventListener('toggle', () => {
    if (details.open) {
      syncHeight();
      if (activeCollection) {
        const activeItem = [...items].find((item) => item.querySelector('a').href.includes(activeCollection));
        if (activeItem) {
          setActive(activeItem);
        }
      }
    } else {
      items.forEach((el) => el.classList.remove('is-active'));
      content.classList.remove('is-active-content');
    }
  });
})();